import { CONTACT_SERVICES } from "@/data/contact"

/** 公開ページのパスだけを受け付ける。自由なURL・クエリは保存しない。 */
export const CONTACT_SOURCE_SERVICES = {
  "/": undefined,
  "/business": undefined,
  "/company": undefined,
  "/brand": undefined,
  "/developers": undefined,
  "/privacy": undefined,
  "/recruit": undefined,
  "/contact": undefined,
  "/materials": undefined,
  "/gallery": undefined,
  "/guides": undefined,
  "/links/brick": "yoshinani-brick",
  "/business/ai": "ax-consulting",
  "/business/line-chatbot": "line-chatbot",
  "/business/line-chatbot/pricing": "line-chatbot",
  "/business/yoshinani-shindan": "yoshinani-shindan",
  "/business/3d-print": "3d-print",
  "/business/line-mini-app": "line-mini-app",
  "/business/line-mini-app/pricing": "line-mini-app",
  "/business/line-mini-app/cases": "line-mini-app",
  "/business/line-mini-app/demos": "line-mini-app",
  "/business/yoshinani-brick": "yoshinani-brick",
  "/business/yoshinani-brick/estimate": "yoshinani-brick",
  "/business/yoshinani-brick/flow": "yoshinani-brick",
  "/business/yoshinani-brick/works": "yoshinani-brick",
  "/business/yoshinani-brick/works/komatsu-ibaraki": "yoshinani-brick",
  "/guides/3d-print-request": "3d-print",
  "/guides/ai-chatbot-rag": "line-chatbot",
  "/guides/ai-website-security-checklist": "yoshinani-shindan",
  "/guides/large-lego-display": "yoshinani-brick",
  "/guides/liff-vs-line-mini-app": "line-mini-app",
  "/guides/line-chatbot-development": "line-chatbot",
  "/guides/line-mini-app-development": "line-mini-app",
} as const

export function contactSource(path: unknown) {
  return typeof path === "string" &&
    Object.hasOwn(CONTACT_SOURCE_SERVICES, path)
    ? (path as keyof typeof CONTACT_SOURCE_SERVICES)
    : undefined
}

/** 明示された制作例のサービスを優先し、共通ナビは現在のページから補う。 */
export function contextualContactHref(href: string, pathname: string) {
  const url = new URL(href, "https://yoshinani.co.jp")
  if (url.origin !== "https://yoshinani.co.jp" || url.pathname !== "/contact")
    return href
  const source = contactSource(pathname)
  if (!source || source === "/contact") return href
  const service =
    CONTACT_SERVICES.find(({ id }) => id === url.searchParams.get("service"))
      ?.id ?? CONTACT_SOURCE_SERVICES[source]
  if (service) url.searchParams.set("service", service)
  if (!url.searchParams.has("topic") && source === "/brand")
    url.searchParams.set("topic", "brand")
  if (!url.searchParams.has("topic") && source === "/developers")
    url.searchParams.set("topic", "partnership")
  url.searchParams.set("from", source)
  return `${url.pathname}${url.search}${url.hash}`
}
